module.exports = __webpack_public_path__ + "static/media/code.94ba307b.jpg";